module.exports = __webpack_public_path__ + "img/l4.9dd3c15c.png";